import { logException } from "@wss/error-tracking";
import { ThrowableStatus } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { CategoryInternalNotesResult } from "~/common/Store/models/ProductListing";

async function logError(e: unknown) {
  const error = new Error("Error in getCategoryInternalNotes", {
    cause: toError(e),
  });

  await logException(error);

  return error;
}

export async function getCategoryInternalNotes(
  categoryId: number,
): Promise<ThrowableStatus<CategoryInternalNotesResult>> {
  try {
    const response = await fetch(
      `/api/productlisting/internalnotes?categoryId=${categoryId}`,
    );

    if (!response.ok) {
      return {
        isError: true,
        status: response.status,
        error: await logError(
          `${response.status}: ${response.statusText}, ${await response.text()}`,
        ),
      };
    }

    return {
      isError: false,
      value: await response.json<CategoryInternalNotesResult>(),
    };
  } catch (e) {
    return { isError: true, error: await logError(e), status: null };
  }
}
